/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/img-redundant-alt */
import { Breadcrumb, Col, Empty, Row, Statistic, Tabs } from "antd";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { AuctionMethodCode, AuctionTypeCode, fileTypes, ItemCardStatus, preCostTypes, registerTypes, SocketBody, SocketMessage } from "../../../common/types/types";


// import required modules
import ProductDetail from "./components/ProductDetail";
import SellerDetail from "./components/SellerDetail";
import RelatedDocuments from "./components/RelatedDocuments";
import AuctionHistory from "./components/AuctionHistory";
import { addMinutes, differenceInMilliseconds, differenceInMinutes, differenceInSeconds, format, intervalToDuration, isBefore, isEqual } from "date-fns";
import { BidderAcceptBidStatus, StartStatus, WebsocketDestination, WebsocketTypes } from "../../types";
import { useGetBargainByIndexMutation, useLazyCheckBargainProductQuery, useLazyGetClientAuctionItemQuery, useLazyGetClientAuctionListQuery, useLazyGetCurrentBargainProductQuery } from "../../redux/AuctionApi";
import StatuteDetail from "./components/StatuteDetail";
import { useLazyGetFileByObjectIdAndTypeQuery } from "../../../../redux/api/FileApi";
import ItemCard from "../../../common/components/ItemCard";
import { CompatClient, Stomp } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import RegisterAuction from "../auction-list/components/RegisterAuction";
import PrepayModal from "../../../common/components/PrepayModal";
import AuctionItemDetail from "./components/AuctionItemDetail";
import AuctionItemStatus from "./components/AuctionItemStatus";
import AuctionPriceStatus from "./components/AuctionPriceStatus";
import { useLazyGetSpecsListQuery } from "../../../../redux/api/SystemApi";
import { useAppDispatch, useAppSelector } from "../../../../redux/Hooks";
import { setCheckWinTrigger, setDefault, setLevel, setSkippedRound, setUpAuctionFinish, toggleAcceptOpen } from "../../redux/AuctionSlice";
import { UploadFileResponse } from "../../../../redux/api/apiTypes";
import AuctionSwiper from "../../../common/components/AuctionSwiper";
import ConfirmModal from "../../../common/components/ConfirmModal";
import WebsocketReconnectModal from "./components/WebsocketReconnectModal";
import { ReactComponent as NotPublic } from '../../../../assets/images/not_public.svg';
import { toggleLoginModal } from "../../../login/redux/LoginSlice";

const { TabPane } = Tabs;

interface Countdown {
    day: number,
    hour: number,
    minute: number,
    second: number
}

const defaultCountdown: Countdown = {
    day: 0,
    hour: 0,
    minute: 0,
    second: 0,
}

const AuctionItem = () => {
    const [countdown, setCountdown] = useState<Countdown>(defaultCountdown);
    const [tabs, setTabs] = useState(1)
    const [imageList, setImageList] = useState<UploadFileResponse[]>([]);
    const [startingPrice, setStartingPrice] = useState(0);
    const [socketUpdate, setSocketUpdate] = useState(false);
    const [newPayload, setNewPayload] = useState<SocketMessage>();
    const [registerVisible, setRegisterVisible] = useState(false);
    const [prepayVisible, setPrepayVisible] = useState(false);
    const [secondUserVisible, setSecondUserVisible] = useState(false);
    const [failVisible, setFailVisible] = useState(false);
    const [websocketErrorVisible, setWebsocketErrorVisible] = useState(false);
    const [isWinner, setIsWinner] = useState(-1); // 1 nếu người dùng nhận được modal trúng đấu giá, 0 nếu không nhận được, default -1
    const timer: { current: NodeJS.Timeout | null } = useRef(null);
    const timerEnded = useRef(false);
    const [hasShownModals, setHasShownModals] = useState(false);
    const [checkFinish, setCheckFinish] = useState(false);

    const params = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const auctionState = useAppSelector(state => state.auction);
    const userState = useAppSelector(state => state.login);

    const [trigger, response] = useLazyGetClientAuctionItemQuery();
    const [fileTrigger] = useLazyGetFileByObjectIdAndTypeQuery();
    const [listTrigger, listResponse] = useLazyGetClientAuctionListQuery();
    const [currentBidTrigger, currentBidResponse] = useLazyGetCurrentBargainProductQuery();
    const [specsTrigger, specsResponse] = useLazyGetSpecsListQuery();
    const [getBargainByIndex, bargainByIndexResponse] = useGetBargainByIndexMutation();
    const [checkBargainProduct] = useLazyCheckBargainProductQuery();

    const divRef = useRef<HTMLDivElement>(null);
    const countdownLoaded = useRef(false);

    const stompClient = useRef<CompatClient>();

    const onError = () => {
        console.error("Websocket failed");
        setWebsocketErrorVisible(true);
    }

    const triggerFetch = useCallback(() => {
        if (params.id && params.statuteId) {
            trigger({ productId: parseInt(params.id), statuteId: parseInt(params.statuteId) });
        }
    }, [params.id, params.statuteId, trigger])

    const onStartingPriceChange = useCallback(() => {
        if (params.id && parseInt(params.id) && response.data?.statute.auctionType?.code !== AuctionTypeCode.HAVE_ROUND) {
            currentBidTrigger(parseInt(params.id));
            triggerFetch();
        }
    }, [currentBidTrigger, params.id, response.data?.statute.auctionType?.code, triggerFetch])

    const onMessageReceived = (payload: any) => {
        const message: SocketMessage = JSON.parse(payload.body);
        console.log(message.type);
        if (Object.values(WebsocketTypes).includes(message.type as WebsocketTypes) && message.productId === response.data?.productId) {
            setNewPayload({ ...message });
        }
    }

    useEffect(() => {
        if (stompClient.current && stompClient.current?.connected && response.data?.startStatus === StartStatus.ONGOING) {
            let body: SocketBody = {
                userId: userState.user?.userId,
                sender: userState.user?.fullName,
                type: WebsocketTypes.ONLINE,
                mapProductValue: {},
                productId: response.data?.productId,
            };
            if (params.id) {
                body.mapProductValue[params.id] = { productId: parseInt(params.id) };
            }
            console.log("start online");

            stompClient.current.publish({
                destination: WebsocketDestination.ADD_USER,
                body: JSON.stringify(body)
            })
        }
    }, [params.id, response.data?.productId, response.data?.startStatus, userState.user?.fullName, userState.user?.userId])

    useEffect(() => {
        // Khi nhận được Websocket với productId tương ứng
        if (newPayload && newPayload.productId && newPayload.productId === response.data?.productId) {
            setSocketUpdate(true);

            if (response.data?.statute?.auctionType?.code !== AuctionTypeCode.HAVE_ROUND && newPayload.type !== WebsocketTypes.ONLINE &&
                newPayload.type !== WebsocketTypes.OFFLINE) {
                onStartingPriceChange();
            }

            // Nếu xác nhận trúng đấu giá, từ chối trúng dừng quy chế, đổi trạng thái sản phẩm, truất quyền 
            // thì call lấy lại thông tin
            if (
                newPayload.type === WebsocketTypes.XAC_NHAN_GIA_TRUNG ||
                newPayload.type === WebsocketTypes.TU_CHOI_GIA_TRUNG ||
                newPayload.type === WebsocketTypes.PAUSE_PRODUCT_STATUTE ||
                newPayload.type === WebsocketTypes.PRODUCT_STATUS ||
                newPayload.type === WebsocketTypes.TRUAT_QUYEN ||
                newPayload.type === WebsocketTypes.DGV_TRUAT_QUYEN ||
                newPayload.type === WebsocketTypes.CHAP_NHAN_TRUNG
            ) {
                triggerFetch();
            }
        }
    }, [newPayload, onStartingPriceChange, response.data?.productId, response.data?.statute?.auctionType?.code, triggerFetch])

    const onConnected = useCallback(() => {
        if (stompClient.current) {
            setWebsocketErrorVisible(false);
            stompClient.current.subscribe('/topic/group/bargain-product', onMessageReceived);

            let body: SocketBody = {
                userId: userState.user?.userId,
                sender: userState.user?.fullName,
                type: WebsocketTypes.ONLINE,
                mapProductValue: {},
                productId: response.data?.productId,
            };
            if (params.id) {
                body.mapProductValue[params.id] = { productId: parseInt(params.id) };
            }
            console.log("start online");

            stompClient.current.publish({
                destination: WebsocketDestination.ADD_USER,
                body: JSON.stringify(body)
            })
        }
    }, [params.id, response.data?.productId, userState.user?.fullName, userState.user?.userId])

    const onWebsocketDisconnect = useCallback(() => {
        if (response.data?.startStatus === StartStatus.ONGOING && stompClient.current
            && (!response.data?.bidderAcceptBid || response.data.bidderAcceptBid.status === BidderAcceptBidStatus.DONE)) {
            // Connect lại nếu bị disconnect
            const headers = {
                'X-Authorization': 'token',
            }
            if (stompClient.current.active) {
                stompClient.current.connect(headers, onConnected, onError);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [response.data?.startStatus])

    const checkSkipRound = useCallback(() => {
        if (response.data?.productId && userState.user.userId && !auctionState.skippedRound && auctionState.level > 1 && response.data?.startStatus === StartStatus.ONGOING) {
            let baseArray = auctionState.level - 1 > 0 ? Array(auctionState.level - 1) : Array(1);
            let levels = Array.from(baseArray, (x, i) => (i + 1));

            if (response.data?.registerStatus === registerTypes.SUCCESS && response.data?.prePaymentStatus === preCostTypes.DONE) {
                checkBargainProduct({
                    levels,
                    productId: response.data?.productId,
                    userId: userState.user.userId,
                }).unwrap().then((res) => {
                    let skippedRound = false;
                    for (let i = 0; i < levels.length; i++) {
                        if (!res.some(item => item.level === levels[i])) {
                            skippedRound = true;
                            break;
                        }
                    }

                    dispatch(setSkippedRound(skippedRound));
                })
            }
        }
    }, [auctionState.level, auctionState.skippedRound, checkBargainProduct, dispatch, response.data?.prePaymentStatus,
    response.data?.productId, response.data?.registerStatus, response.data?.startStatus, userState.user.userId])

    useEffect(() => {
        if (failVisible && userState.user.userId && response.data?.productId && response.data?.statute.statuteId) {
            localStorage.setItem(`${userState.user.userId}-${response.data?.productId}-${response.data?.statute.statuteId}`, JSON.stringify(true))
            setHasShownModals(true);
        }
    }, [failVisible, response.data?.productId, response.data?.statute.statuteId, userState.user.userId])

    useEffect(() => {
        if (hasShownModals) {
            setCheckFinish(true);
        }
    }, [hasShownModals])

    useEffect(() => {
        if (userState.user.userId && response.data?.productId && response.data?.statute.statuteId) {
            let userId = userState.user.userId;
            let productId = response.data?.productId;
            let statuteId = response.data?.statute.statuteId;
            let value = localStorage.getItem(`${userId}-${productId}-${statuteId}`);
            let shownModals = false;

            if (value && JSON.parse(value) === true) {
                shownModals = true;
            }

            if (shownModals) {
                setHasShownModals(shownModals);
            } else {
                setCheckFinish(true);
            }
        }
    }, [response.data?.productId, response.data?.statute.statuteId, userState.user.userId])

    useEffect(() => {
        if (params.id && params.statuteId) {
            if (divRef.current) {
                divRef.current.scrollIntoView({ behavior: 'smooth' });
            }
            specsTrigger({})
        }
    }, [params.id, params.statuteId, specsTrigger])

    useEffect(() => {
        // Reset state về mặc định
        console.log("setting default");
        dispatch(setDefault());

        return (() => {
            // Reset cả khi unmount
            dispatch(setDefault());
        })
    }, [dispatch])

    useEffect(() => {
        if (response.data?.startStatus !== StartStatus.UPCOMING && response.data?.productId) {
            // Lấy lịch sử trả giá
            currentBidTrigger(response.data.productId);

            // Nếu trạng thái đấu giá thay đổi, đặt timerEnded về false
            timerEnded.current = false;
        }
    }, [currentBidTrigger, response.data?.productId, response.data?.startStatus])

    useEffect(() => {
        // Lấy danh sách tài sản khác cùng quy chế
        if (response.data?.startStatus && response.data?.statute.statuteId) {
            listTrigger({
                page: 0,
                size: 6,
                type: 0,
                statuteId: response.data.statute.statuteId,
            })
        }

    }, [listTrigger, response.data?.startStatus, response.data?.statute.statuteId])

    useEffect(() => {
        if (params.id && params.statuteId) {
            trigger({ productId: parseInt(params.id), statuteId: parseInt(params.statuteId) });
            fileTrigger({
                objectId: parseInt(params.id),
                objectType: fileTypes.PRODUCT,
            }).unwrap().then(res => {
                if (res?.length) {
                    setImageList(res.filter(item => item.storageType === "image" || item.storageType === "avatar"))
                }
            });
        }
    }, [fileTrigger, params.id, params.statuteId, trigger])

    useEffect(() => {
        let tabNumber = searchParams.get("tab")
        if (tabNumber && parseInt(tabNumber)) {
            setTabs(parseInt(tabNumber));
        }

    }, [searchParams])

    useEffect(() => {
        // Websocket
        if (response.data?.productId
            && (response.data?.startStatus === StartStatus.ONGOING || response.data?.startStatus === StartStatus.UPCOMING)
            && (!stompClient.current || !stompClient.current.active)) {
            if (!stompClient.current) {
                stompClient.current = Stomp.over(function () {
                    return new SockJS(process.env.REACT_APP_API_URL + "/ws")
                });
            }

            const headers = {
                'X-Authorization': 'token',
            }

            // Chưa connect được websocket thì mới connect
            if (!stompClient.current.active) {
                stompClient.current.connect(headers, onConnected, onError);
            }

            stompClient.current.onDisconnect = (receipt) => {
                onWebsocketDisconnect();
            }
        }

        // return () => {
        //     if (stompClient.current) {
        //         stompClient.current.deactivate();
        //         console.log("DEACTIVATING");
        //     }
        // }

    }, [onConnected, onWebsocketDisconnect, response.data?.productId, response.data?.startStatus])

    useEffect(() => {
        timer.current = setInterval(() => {
            let currentDate = new Date();

            // Tính số vòng hiện tại
            let currentRound = 0;
            let endAuctionTime = 0;
            if (response.data?.startAuctionDate && response.data?.statute?.incrementInTimePerBid && response.data?.statute?.totalRound) {
                let timeDiff = differenceInMilliseconds(currentDate, response.data.startAuctionDate);
                currentRound = Math.ceil(timeDiff / (response.data.statute.incrementInTimePerBid * 60 * 1000));

                if (currentRound > response.data.statute.totalRound) {
                    currentRound = response.data.statute.totalRound;
                }

                // Xác định vòng - Sau khi hết vòng cuối, xác định người trúng đấu giá
                endAuctionTime = addMinutes(response.data.startAuctionDate, response.data.statute.incrementInTimePerBid * response.data.statute.totalRound).getTime();
            } else if (response.data?.startAuctionDate && response.data?.statute?.timePerProduct) {
                // Không xác định vòng - Sau khi hết thời gian đấu giá sản phẩm, xác định người trúng đấu giá
                endAuctionTime = addMinutes(response.data.startAuctionDate, response.data.statute.timePerProduct).getTime();
            }

            if (differenceInSeconds(currentDate, endAuctionTime) >= 0 && response.data?.startStatus === StartStatus.ONGOING) {
                //  && response.data.bidderAcceptBid?.status === BidderAcceptBidStatus.DONE) {
                dispatch(setCheckWinTrigger(true));

                if (response.data?.statute?.auctionMethod?.code === AuctionMethodCode.INCREASE) {
                    dispatch(setUpAuctionFinish(true));
                }
            }

            dispatch(setLevel(currentRound));

            // Cập nhật countdown
            let toDate = response.data?.startAuctionDate;
            let freezeTime = 0;

            if (response.data?.startStatus === StartStatus.ONGOING) {
                toDate = response.data?.endAuctionDate;
                if (response.data?.statute?.auctionType?.code === AuctionTypeCode.NOT_ROUND && !auctionState.upAuctionFinish && response.data?.statute?.timePerProduct) {
                    // Trả giá lên không xác định vòng
                    toDate = addMinutes(response.data?.startAuctionDate, response.data?.statute?.timePerProduct).getTime();
                }

                if (response.data?.statute?.auctionType?.code === AuctionTypeCode.HAVE_ROUND && !auctionState.upAuctionFinish
                    && response.data?.statute?.incrementInTimePerBid) {
                    // Đếm ngược theo từng vòng
                    toDate = addMinutes(response.data?.startAuctionDate, currentRound * response.data?.statute?.incrementInTimePerBid).getTime();
                }

                if (response?.data?.statute.auctionMethod?.code === AuctionMethodCode.DECREASE && response.data?.statute?.timePerPriceDown
                    && response.data.biddingDownPerTurn && specsResponse.data?.length) {
                    // Trả giá xuống
                    let numOfRound = Math.floor((response.data.startPrice - response.data.minPrice) / response.data.biddingDownPerTurn);

                    const timeToUserOneConfirm = specsResponse.data?.find(item => item.configKey === "timeToUserOneConfirm")?.configValue || 1;
                    const breakTime = specsResponse.data?.find(item => item.configKey === "relexTime")?.configValue || 1;
                    let defaultEndTime = 0;

                    defaultEndTime = addMinutes(response.data?.startAuctionDate, numOfRound * (response.data?.statute?.timePerPriceDown + timeToUserOneConfirm) + breakTime).getTime();

                    if (response.data?.statute.allowWithdrawPaid) {
                        const withdrawTime = specsResponse.data?.find(item => item.configKey === "timeAllowedToWithdrawPrice")?.configValue || 1;
                        defaultEndTime = addMinutes(defaultEndTime, numOfRound * withdrawTime).getTime();
                    }
                    // Tính tổng thời gian cuộc đấu giá đã bị tạm dừng
                    freezeTime = differenceInMilliseconds(response.data?.endAuctionDate, defaultEndTime);
                    // console.log(response.data?.endAuctionDate - defaultEndTime);
                    if (response.data?.bidderAcceptBid?.createdDate) {
                        freezeTime = differenceInMilliseconds(currentDate, response.data?.bidderAcceptBid?.createdDate);
                    }

                    let timeDiff = differenceInMilliseconds(currentDate, response.data.startAuctionDate + freezeTime);

                    let currentRound = Math.ceil(timeDiff / (response.data?.statute.timePerPriceDown * 60 * 1000));

                    if (currentRound > numOfRound) {
                        currentRound = numOfRound;
                    }

                    toDate = addMinutes(response.data?.startAuctionDate + freezeTime, currentRound * response.data?.statute?.timePerPriceDown).getTime();
                }
            }

            let endDate = toDate ? new Date(toDate) : currentDate;
            if (isBefore(endDate, currentDate) || isEqual(endDate, currentDate)) {
                // Đặt countdown về 0 khi hết thời gian
                setCountdown({
                    day: 0,
                    hour: 0,
                    minute: 0,
                    second: 0,
                })
                countdownLoaded.current = true;

                if (timer.current) {
                    clearInterval(timer.current);
                    timer.current = null;
                }
            } else {
                // Tính thời gian còn lại để hiển thị ở countdown
                let difference = intervalToDuration({ start: new Date(), end: endDate });
                if (response.data?.productId && (!auctionState.stopCountdown || !countdownLoaded.current)) {
                    setCountdown({
                        day: difference.days || 0,
                        hour: difference.hours || 0,
                        minute: difference.minutes || 0,
                        second: difference.seconds || 0,
                    })
                    countdownLoaded.current = true;
                    timerEnded.current = false;

                    if (response.data && response.data?.statute?.auctionType?.id === 2 && response.data.statute?.timePerPriceDown) {
                        // Tính giá hiện tại trong trường hợp đặt giá xuống

                        let timePassInMinutes = differenceInMinutes(new Date(), new Date(response.data?.startAuctionDate + freezeTime));

                        let newStartingPrice = response.data.startPrice - response.data.biddingDownPerTurn *
                            Math.floor(timePassInMinutes / response.data.statute.timePerPriceDown);
                        setStartingPrice(newStartingPrice < response.data?.minPrice ? response.data?.minPrice : newStartingPrice);
                    }
                }
            }

        }, 1000)

        return () => {
            if (timer.current) {
                clearInterval(timer.current);
            }
        };
    }, [dispatch, userState.user.userId, trigger, auctionState.upAuctionFinish, auctionState.stopCountdown, response.data, specsResponse.data])

    useEffect(() => {
        // Gọi API khi countdown đã hết
        if (!Object.values(countdown).some(item => item !== 0) && response.isSuccess && response.data?.productId &&
            (response.data?.startStatus === StartStatus.ONGOING || response.data?.startStatus === StartStatus.UPCOMING)) {
            if (!timerEnded.current) {
                // console.log("asdasdas d asdasdas d");
                // Nếu bắt đầu đấu giá thì gọi api update thời gian online
                if (response.data?.startStatus === StartStatus.UPCOMING && stompClient.current) {
                    // console.log("huybvasdasdasd")
                    const headers = {
                        'X-Authorization': 'token',
                    }
                    stompClient.current.connect(headers, onConnected, onError);
                }
                trigger({ productId: response.data.productId, statuteId: response.data.statute.statuteId }).unwrap().then(res => {
                    if (res.startStatus !== StartStatus.UPCOMING) {
                        // console.log("huybvasdasdasd242343")
                        timerEnded.current = true;  // Không load liên tục khi countdown dừng ở 0
                    }
                });
            }

            if (response.data?.startStatus === StartStatus.ONGOING && response.data?.statute?.auctionType?.code === AuctionTypeCode.HAVE_ROUND) {
                // Kiểm tra người dùng có bỏ qua vòng đấu giá hay không
                checkSkipRound();
            }
        }
    }, [checkSkipRound, countdown, onConnected, response.data?.productId, response.data?.startStatus,
        response.data?.statute?.auctionType?.code, response.data?.statute.statuteId, response.isSuccess, trigger])

    useEffect(() => {
        // Gọi khi kết thúc 1 vòng
        if (!Object.values(countdown).some(item => item !== 0) && response.data?.productId && auctionState.level && params.id && parseInt(params.id)) {
            currentBidTrigger(parseInt(params.id));
        }
    }, [params.id, currentBidTrigger, response.data?.productId, auctionState, countdown])

    useEffect(() => {
        // Kiểm tra người thắng cuộc sau khi hết thời gian và cuộc đấu giá chưa kết thúc
        if (response.data?.productId &&
            auctionState.checkWinTriggered &&
            response.data?.productId &&
            response.data?.startStatus === StartStatus.ONGOING
        ) {
            if (response.data?.statute?.auctionMethod?.code === AuctionMethodCode.INCREASE) {
                dispatch(setUpAuctionFinish(true));
            }
            trigger({ productId: response.data.productId, statuteId: response.data.statute.statuteId }).unwrap().then((res) => {
                let isCurrentWinner = (res.bidderAcceptBid?.user?.userId === userState.user.userId &&
                    res.bidderAcceptBid?.status === BidderAcceptBidStatus.DONE);

                if (!isCurrentWinner && response.data?.statute?.auctionMethod?.code === AuctionMethodCode.INCREASE) {
                    // Lấy thông tin người thứ 2: có giá cao nhất sau người thứ 1, giá trả + tiền đặt trước  >= giá của người cao nhất
                    getBargainByIndex({ productId: response.data?.productId || 0, index: 1 }).unwrap().then(res => {
                        if (res[0]?.user?.userId === userState.user.userId) {
                            setIsWinner(1);
                        } else {
                            setIsWinner(0);
                        }
                    }).catch(err => {
                        // Do nothing
                    })
                } else {
                    setIsWinner(1);
                }

                if (isCurrentWinner && res.startStatus === StartStatus.ONGOING && !auctionState.declinedWin
                    && response.data?.statute?.auctionMethod?.code === AuctionMethodCode.INCREASE) {
                    setSecondUserVisible(false);
                    dispatch(toggleAcceptOpen(true));
                }
            })
        }
    }, [dispatch, response.data?.productId, trigger, userState.user.userId, newPayload, auctionState.checkWinTriggered,
        response.data?.statute?.auctionMethod?.code, auctionState.declinedWin, response.data?.statute.statuteId, getBargainByIndex,
        response.data?.startStatus])


    useEffect(() => {
        // Hiển thị modal cho người thứ 2 trong khi người thứ 1 xác nhận
        // Trường hợp đấu giá theo vòng
        if (response.data?.statute?.auctionMethod?.code === AuctionMethodCode.INCREASE &&
            !response.data?.timeRefusebargainFirt &&
            bargainByIndexResponse.data?.[0]?.user.userId === userState.user.userId &&
            response.data?.startStatus === StartStatus.ONGOING &&
            auctionState.checkWinTriggered && response.data.bidderResponseDTO?.isActive !== 1
        ) {
            setSecondUserVisible(true);
        }
    }, [auctionState.acceptOpen, auctionState.checkWinTriggered, bargainByIndexResponse.data,
    response.data?.bidderResponseDTO?.isActive, response.data?.startStatus, response.data?.statute?.auctionMethod?.code,
    response.data?.timeRefusebargainFirt, userState.user.userId])

    useEffect(() => {
        // Hiển thị modal không trúng đấu giá
        let showFailModal = false;
        if (response.data?.statute?.auctionMethod?.code === AuctionMethodCode.DECREASE &&
            ((newPayload?.mapProductValue && newPayload?.userId && newPayload?.type === WebsocketTypes.TRA_GIA) || (response.data?.bidderAcceptBid?.user?.userId)
                || (newPayload?.type === WebsocketTypes.CHAP_NHAN_TRUNG))) {
            // Trường hợp đấu giá xuống
            let userId = 0;
            // if (newPayload?.mapProductValue && newPayload.userId) {
            //     userId = newPayload.userId;
            // } else 
            if (response.data?.bidderAcceptBid?.user?.userId) {
                userId = response.data.bidderAcceptBid.user.userId;
            }

            if (userId !== userState.user.userId
                && (!response.data.statute.allowWithdrawPaid ||
                    (response.data.bidderAcceptBid?.status === BidderAcceptBidStatus.ACCEPT || response.data.bidderAcceptBid?.status === BidderAcceptBidStatus.SUCCESS))) {
                showFailModal = true;
            }
        }

        if (response.data?.statute?.auctionMethod?.code === AuctionMethodCode.INCREASE && auctionState.upAuctionFinish) {
            // Trường hợp đấu giá lên
            if (((response.data.bidderAcceptBid?.user?.userId && response.data.bidderAcceptBid.user.userId !== userState.user.userId) || !response.data.bidderAcceptBid)
                && (!bargainByIndexResponse.data?.[0]?.user.userId || bargainByIndexResponse.data?.[0]?.user?.userId !== userState.user.userId)
                && (isWinner === 0)) {
                showFailModal = true;
            }
        }

        if (((newPayload?.type === WebsocketTypes.XAC_NHAN_GIA_TRUNG && newPayload?.userId && newPayload.userId !== userState.user.userId) ||
            (response.data?.startStatus === StartStatus.FINISH && (!response.data.bidderAcceptBid || response.data.bidderAcceptBid.user?.userId !== userState.user.userId))) &&
            response.data?.bidderResponseDTO?.registerStatus === registerTypes.SUCCESS && response.data.bidderResponseDTO?.preCostStatus === preCostTypes.DONE) {
            // Hiển thị modal không trúng đấu giá khi có người khác ấn xác nhận
            showFailModal = true;
        }

        // Kiểm tra đã show modal kết quả đấu giá hay chưa
        let value = localStorage.getItem(`${userState.user.userId}-${response.data?.productId}-${response.data?.statute.statuteId}`);
        let shownModals = false;

        if (value && JSON.parse(value) === true) {
            shownModals = true;
        }

        if (showFailModal && !shownModals && checkFinish) {
            setFailVisible(true);
        }
    }, [auctionState.upAuctionFinish, bargainByIndexResponse.data, isWinner, newPayload?.mapProductValue, 
        newPayload?.type, newPayload?.userId, response.data?.bidderAcceptBid, response.data?.bidderAcceptBid?.status, 
        response.data?.bidderAcceptBid?.user?.userId, response.data?.bidderResponseDTO?.preCostStatus, response.data?.bidderResponseDTO?.registerStatus, 
        response.data?.startStatus, response.data?.statute.allowWithdrawPaid, response.data?.statute?.auctionMethod?.code, 
        userState.user.userId, checkFinish, response.data?.statute.statuteId, response.data?.productId])

    useEffect(() => {
        if (response.data?.startStatus === StartStatus.ONGOING && response.data?.statute?.auctionType?.code === AuctionTypeCode.HAVE_ROUND
            && response.data?.statute.totalRound && response.data?.statute.totalRound > 1) {
            checkSkipRound();
        }
    }, [checkBargainProduct, response.data?.startStatus, response.data?.statute?.auctionType?.code, dispatch, checkSkipRound, response.data?.statute.totalRound])


    const onTabClick = (currentTab: number) => {
        setTabs(currentTab);
        navigate(location.pathname + "?tab=" + currentTab)
    }

    const generateMoreItems = () => {
        if (listResponse.data?.content.length) {
            let auctionList = listResponse.data.content.filter(item => item.productId !== response.data?.productId).slice(0, 5);
            let returnData: React.ReactNode[] = [];

            let url = "";
            if (response.data?.startStatus === StartStatus.UPCOMING) {
                url = "/auction-list/upcoming";
            } else if (response.data?.startStatus === StartStatus.ONGOING) {
                url = "/auction-list/ongoing";
            } else if (response.data?.startStatus === StartStatus.FINISH) {
                url = "/auction-list/finish";
            }

            if (listResponse.data?.totalElements > 6) {
                returnData.push(
                    <Col span={24} key="more">
                        <Row justify="center">
                            <Col
                                style={{ textAlign: 'right' }}
                                md={8 * auctionList.length >= 24 ? 24 : 8 * auctionList.length}
                                lg={6 * auctionList.length >= 24 ? 24 : 6 * auctionList.length}
                                xl={4 * auctionList.length >= 24 ? 24 : 4 * auctionList.length}
                            >
                                <Link to={url} key={url}>
                                    Xem thêm
                                </Link>
                            </Col>
                        </Row>
                    </Col>
                )
            }
            for (let i = 0; i < auctionList.length; i++) {
                let status = ItemCardStatus.SUCCESS;
                switch (auctionList[i].startStatus) {
                    case StartStatus.UPCOMING:
                        status = ItemCardStatus.NEW;
                        break;
                    case StartStatus.ONGOING:
                        status = ItemCardStatus.INPROGRESS;
                        break;
                    case StartStatus.PAUSE:
                        status = ItemCardStatus.PAUSE;
                        break;
                    case StartStatus.FINISH:
                        status = ItemCardStatus.SUCCESS;
                        break;
                    default:
                        status = ItemCardStatus.NEW;
                        break;
                }

                if (auctionList[i].bidderAcceptBid?.status === 3) {
                    status = ItemCardStatus.FAILED;
                }
                returnData.push(
                    <Col md={8} lg={6} xl={4} key={auctionList[i].productId} className="item-card-price-small">
                        <ItemCard
                            status={status}
                            item={auctionList[i]}
                            reloadPage={() => {
                                listTrigger({
                                    page: 0,
                                    size: 6,
                                    status: 124,
                                    type: 0,
                                    startStatus: response.data?.startStatus,
                                })
                            }} />
                    </Col>
                )
            }

            return returnData;
        }
        return (<Col span={24}>Hiện không có dữ liệu tài sản khác</Col>);
    }


    const toggleRegisterModal = () => {
        if (!userState.user.userId) {
            setRegisterVisible(false);
            dispatch(toggleLoginModal());
        } else if (!userState.incompleteProfile) {
            setRegisterVisible(!registerVisible)
        } else if (userState.incompleteProfile) {
            // Nếu chưa hoàn thành hồ sơ
            navigate("/profile/detail/redirect");
        }
    }

    const togglePrepayModal = () => {
        if (prepayVisible) {
            triggerFetch()
        }
        setPrepayVisible(!prepayVisible);
    }

    const toggleSecondUserVisible = () => {
        setSecondUserVisible(!secondUserVisible);
    }

    const toggleFailVisible = () => {
        if (failVisible || (!hasShownModals && checkFinish)) {
            setFailVisible(!failVisible);
        }
    }

    return (
        <div
            ref={divRef}
            style={{
                padding: '40px calc((100vw - 1440px) / 2) 40px',
                background: "#ececec",
                display: 'flex',
                // alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '100%'
            }}
        >
            <Breadcrumb separator="  " className="custom-breadcrumb">
                <Breadcrumb.Item>
                    <Link to="/">
                        Trang chủ
                    </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to={response.data?.startStatus === StartStatus.UPCOMING ? "/auction-list/upcoming" :
                        response.data?.startStatus === StartStatus.ONGOING ? "/auction-list/ongoing" : "/auction-list/finish"}>
                        Danh sách tài sản
                    </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    Chi tiết tài sản
                </Breadcrumb.Item>
            </Breadcrumb>
            <Row gutter={70} style={{ marginTop: '30px', width: '100%' }} className="responsive-padding-1440">
                <Col xs={12} style={{ display: 'flex', flexDirection: 'column', maxHeight: 500 }}>
                    <AuctionSwiper imageList={imageList} key={`${params.id || 0}-${params.statuteId}`} />
                </Col>
                <Col xs={12}>
                    <div style={{ padding: '2px 15px', backgroundColor: '#DCDCDC', display: 'inline-block' }}>
                        <span>Mã tài sản</span>
                        <span className="font-bold"> {response.data?.productCode || ""}</span>
                    </div>
                    <h2 style={{ fontWeight: 'bold' }}>{response.data?.productName || ""}</h2>
                    <div style={{ display: 'flex', justifyContent: 'space-between', lineHeight: '1.2' }}>
                        <div>
                            <div>Giá khởi điểm:</div>
                            <div style={{ fontSize: '26px', display: 'flex', alignItems: 'center' }}>
                                <Statistic
                                    value={response.data?.startPrice || 0}
                                    groupSeparator="."
                                    decimalSeparator=","
                                    precision={0}
                                    style={{ marginRight: 5 }}
                                    valueStyle={{ fontSize: 26, fontFamily: 'Quicksand' }} /> VNĐ
                            </div>
                        </div>
                        <div style={{ textAlign: 'right', marginTop: '10px' }}>
                            <div>
                                <small>Thời gian bắt đầu phiên đấu giá:</small>
                            </div>
                            <small style={{ fontWeight: 'bold' }}>{response.data?.startAuctionDate ? format(response.data.startAuctionDate, "HH:mm:ss dd/MM/yyyy") : ""}</small>
                        </div>
                    </div>

                    <AuctionPriceStatus
                        toggleSecondUserVisible={toggleSecondUserVisible}
                        secondUserVisible={secondUserVisible}
                        bargainIndex={bargainByIndexResponse.data || []}
                        setFailVisible={setFailVisible}
                        setSecondUserVisible={setSecondUserVisible}
                        product={response.data}
                        countdown={countdown}
                        startingPrice={startingPrice}
                        currentBid={currentBidResponse.data}
                        setStartingPrice={setStartingPrice}
                        onStartingPriceChange={onStartingPriceChange}
                        specsList={specsResponse.data || []}
                        socketMessage={newPayload}
                        triggerFetch={triggerFetch}
                        hasShownModals={hasShownModals}
                        setHasShownModals={setHasShownModals}
                        checkFinish={checkFinish}
                        setCheckFinish={setCheckFinish} />

                    <AuctionItemDetail product={response.data} />
                    <AuctionItemStatus
                        socketMessage={newPayload}
                        product={response.data}
                        togglePrepayModal={togglePrepayModal}
                        toggleRegisterModal={toggleRegisterModal}
                        triggerFetch={triggerFetch} />
                </Col>
            </Row>
            <Row justify="center" style={{ width: '100%' }}>
                <Col xs={20}>
                    <div style={{ marginTop: '80px', borderRadius: '15px', background: 'white', padding: '70px 50px 140px 50px', position: 'relative' }}>
                        <div className="tab">
                            <Tabs type="card" className="custom-tab" onChange={(tab) => { onTabClick(Number(tab)) }} activeKey={tabs.toString()}>
                                <TabPane tab="THÔNG TIN TÀI SẢN" key="1">
                                </TabPane>
                                <TabPane tab="THÔNG TIN TỔ CHỨC ĐẤU GIÁ / NGƯỜI CÓ TÀI SẢN" key="2">
                                </TabPane>
                                <TabPane tab="QUY CHẾ ĐẤU GIÁ" key="3">
                                </TabPane>
                                <TabPane tab="TÀI LIỆU LIÊN QUAN" key="4">
                                </TabPane>
                                {response.data?.startStatus !== StartStatus.UPCOMING ?
                                    // (response.data?.statute.publicProgressAuction
                                    //     || response.data?.seller.userId === userState.user.userId
                                    //     || (response.data?.bidderResponseDTO?.registerStatus === registerTypes.SUCCESS && response.data.bidderResponseDTO.preCostStatus === preCostTypes.DONE)) ?
                                    <TabPane tab="LỊCH SỬ ĐẤU GIÁ" key="5"></TabPane>
                                    : <></>}
                            </Tabs>
                        </div>
                        {tabs === 1 && <ProductDetail item={response.data} />}
                        {tabs === 2 && <SellerDetail item={response.data} />}
                        {tabs === 3 && <StatuteDetail item={response.data} />}
                        {tabs === 4 && <RelatedDocuments item={response.data} />}
                        {tabs === 5 &&
                            <>
                                {(response.data?.statute.publicProgressAuction
                                    || response.data?.seller.userId === userState.user.userId
                                    || (response.data?.bidderResponseDTO?.registerStatus === registerTypes.SUCCESS &&
                                        response.data.bidderResponseDTO.preCostStatus === preCostTypes.DONE)) ?
                                    <AuctionHistory item={response.data} socketUpdate={socketUpdate} setSocketUpdate={setSocketUpdate} newPayload={newPayload} /> :
                                    <Empty image={<NotPublic />} description="Đây là đấu giá không công khai, bạn không thể xem nội dung này" />}
                            </>
                        }

                    </div>

                </Col>
            </Row>
            {listResponse.data?.content.length && listResponse.data.content.length > 1 ?
                <>
                    <div style={{ marginTop: '40px', textAlign: 'center', marginBottom: '10px' }}>
                        <h1 style={{ color: 'black', letterSpacing: '0.1em' }}>TÀI SẢN KHÁC</h1>
                    </div>
                    <Row gutter={[5, 20]} justify="center" style={{ width: '100%' }}>
                        {generateMoreItems()}
                    </Row>
                </> : <></>}

            {registerVisible ? <RegisterAuction
                visible={registerVisible}
                itemId={response?.data?.productId || 0}
                statuteId={response.data?.statute?.statuteId || 0}
                toggleModal={toggleRegisterModal}
                onSuccess={triggerFetch}
            /> : <></>}

            {prepayVisible && response.data ? <PrepayModal
                visible={prepayVisible}
                productId={response.data.productId}
                productName={response.data.productName}
                statuteId={response.data.statute.statuteId}
                preCost={response.data.preCost + (response.data.anotherCost || 0)}
                toggleModal={togglePrepayModal}
                onSuccess={triggerFetch}
            /> : <></>}

            {userState.user.userId &&
                failVisible &&
                response.data?.bidderResponseDTO?.registerStatus === registerTypes.SUCCESS
                && response.data?.bidderResponseDTO?.preCostStatus === preCostTypes.DONE ?
                <ConfirmModal
                    onCancel={toggleFailVisible}
                    onOk={toggleFailVisible}
                    status="error"
                    title={<div style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                        <div className="font-size-16">Rất tiếc, bạn không trúng đấu giá.</div>
                        <div className="font-size-16">Cảm ơn và hẹn gặp lại bạn trong cuộc đấu giá khác!</div>
                    </div>}
                    visible={failVisible}
                    okText="ĐỒNG Ý"
                    noCancelButton={true}
                />
                : <></>}
            {websocketErrorVisible ?
                <WebsocketReconnectModal visible={websocketErrorVisible} /> : <></>}
        </div >
    )
}

export default AuctionItem